import { Routes } from '@angular/router';

export const pricePromotionRoutes: Routes = [
  // Price Profile
  {
    path: 'price-profile',
    data: { moduleCode: 'price_profile' },
    children: [
      { path: '', loadComponent: () => import('./price-profile/price-profile').then((m) => m.PriceProfile) },
      { path: 'add', loadComponent: () => import('./price-profile/price-details/price-details').then((m) => m.PriceDetails) },
      { path: 'details/:id', loadComponent: () => import('./price-profile/price-details/price-details').then((m) => m.PriceDetails) },
      { path: 'import', loadComponent: () => import('./price-profile/price-import/price-import').then((m) => m.PriceImport) }
    ]
  },
  // New Price Profile Creation
  {
    path: 'new-price-profile-creation',
    data: { moduleCode: 'new_price_profile_creation' },
    children: [
      { path: '', loadComponent: () => import('./new-price-profile-req/new-price-profile-req').then((m) => m.NewPriceProfileReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./price-profile/price-details/price-details').then((m) => m.PriceDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },
  // Price Profile Update
  {
    path: 'price-profile-update',
    data: { moduleCode: 'price_profile_upd' },
    children: [
      { path: '', loadComponent: () => import('./update-price-profile-req/update-price-profile-req').then((m) => m.UpdatePriceProfileReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./price-profile/price-details/price-details').then((m) => m.PriceDetails),
        data: { reqModuleType: 'approver' }
      }
    ]
  },
];
